"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _componentData = require("../componentData");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function DistanceFilterDropdown(_ref) {
  var _apiData$data, _apiData$data2;
  var {
    searchState,
    setSearchState,
    apiData,
    onSearch
  } = _ref;
  if (!(apiData !== null && apiData !== void 0 && (_apiData$data = apiData.data) !== null && _apiData$data !== void 0 && (_apiData$data = _apiData$data.data) !== null && _apiData$data !== void 0 && _apiData$data.distancefacet)) return '';

  // Handle special situation where we are returning results 3000+ miles away
  // When constructing the label, add a plus sign in only 3000+ case
  var endIndex = searchState.distanceMiles === '3000' ? 6 : 5;
  var distanceFilterOptions = apiData === null || apiData === void 0 || (_apiData$data2 = apiData.data) === null || _apiData$data2 === void 0 || (_apiData$data2 = _apiData$data2.data) === null || _apiData$data2 === void 0 || (_apiData$data2 = _apiData$data2.distancefacet) === null || _apiData$data2 === void 0 ? void 0 : _apiData$data2.slice(0, endIndex).map((option, index) => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Distance: Within ".concat(_componentData.DISTANCEKEY[index] === 3000 ? '50+' : _componentData.DISTANCEKEY[index], " miles "), /*#__PURE__*/_react.default.createElement("span", {
      className: "copy-sm"
    }, " (".concat(option.doc_count, ")")));
  });
  var label = distanceFilterOptions ? "Distance: Within ".concat(searchState.distanceMiles === '3000' ? '50+' : searchState.distanceMiles, " Miles") : 'Distance: Within 5 Miles';
  return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown, {
    id: "finpro-or-agency",
    className: "form-group right-align-dropdown"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.Toggle, {
    id: "new_dropdown0_toggle",
    label: label,
    "aria-label": "".concat(label ? label + ', selected' : ''),
    type: 'default'
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.Menu, {
    id: "finpro-or-agency-menu"
  }, distanceFilterOptions.map((option, index) => {
    return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Dropdown.DefaultItem, {
      key: index,
      onClick: () => {
        setSearchState(prevState => {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            distanceFilterSelectionIndex: index,
            distanceMiles: _componentData.DISTANCEKEY[index],
            disableNextAvailableDistSearch: true
          });
        });
        onSearch();
      }
    }, option);
  })));
}
var _default = exports.default = DistanceFilterDropdown;